<template>
    <div>
      <el-select multiple class="select"
                 size="large"
                 placeholder="Department"
                 v-model="departments">
        <el-option v-for="option in allDepartments"
                   class="select"
                   :value="option.value"
                   :label="option.label"
                   :key="option.label">
        </el-option>
      </el-select>
      <button type="button" @click.prevent="saveDepartments" class="btn btn-fill btn-info btn-wd btn-edit-departments pull-right">Save Departments</button>
      <div style="clear:both"></div>
    </div>
</template>

<script>
  import {Select, Option} from 'element-ui'
  import {mapGetters} from 'vuex'
  import {notifySuccess, notifyError} from 'src/utilities/utils'
  import Constants from 'src/utilities/constants'
  import {sync} from 'vuex-pathify'

  export default {
    props: ['id'],
    components: {
      [Select.name]: Select,
      [Option.name]: Option
    },
    computed: {
      departments: sync('projects/edit/departments'),
      ...mapGetters({
        allDepartments: 'departments/kvpsForSelect'
      })
    },
    methods: {
      async saveDepartments() {
        const patch = this.$store.get('projects/edit/departmentsGeneratePatch')
        const response = await this.$store.dispatch('patch', patch)
        if (response.result === Constants.RETURN_CODES.SUCCESS) {
          this.$emit('close')
          notifySuccess(this, 'Project Departments Updated Successfully')
        } else {
          notifyError(this, 'Failed to Update Project Departments')
        }
      }
    },
    destroyed() {
      this.$store.set('projects/edit/details/isActiveDepartment', false)
    }
  }
</script>

<style scoped>
  .select {
    width: 100%;
  }
</style>
